import axios from "../lib/axios";
import {MASTER_MAIN_GROUP_FIND_MANY } from "../lib/endpoints/category";
import { SuppliesMainGroupName } from "../models/suppliesMain";


export const getAllMasterMainGroup=async ():Promise<SuppliesMainGroupName[]>=>{
    const res=await axios.post(MASTER_MAIN_GROUP_FIND_MANY);

    return res?.data;
}

export const getMasterMainGroup=async ():Promise<SuppliesMainGroupName[]>=>{
    const res=await axios.post(MASTER_MAIN_GROUP_FIND_MANY);

    return res?.data;
}